/**
 * Texto para busca: minúsculas e sem acento — "medicao" acha "Medição",
 * "LAUDO" acha "laudo". A busca que corre na tela compara sempre por aqui.
 */
export const normalizarBusca = (texto: string): string =>
  texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
